"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ShieldCheck = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ShieldCheck_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.354 6.354a.5.5 0 0 0-.707-.708L7.04 10.251l-1.65-2.063a.5.5 0 1 0-.781.624l2 2.5a.5.5 0 0 0 .744.042l5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.436.16c-.224-.213-.646-.213-.87 0-1.023.972-3.685 3.242-6.2 3.217-.269-.003-.514.178-.538.433-.714 7.766 3.865 11.264 7.122 12.173.034.01.068.01.102 0 3.258-.91 7.836-4.407 7.122-12.173-.024-.255-.27-.436-.537-.433-2.516.025-5.178-2.245-6.2-3.217ZM3.701 11.87c1.25 1.673 2.902 2.647 4.3 3.085 1.398-.438 3.05-1.412 4.3-3.086 1.246-1.668 2.135-4.09 1.913-7.506-1.383-.098-2.705-.715-3.764-1.37A17.01 17.01 0 0 1 8.002 1.12c-.565.515-1.43 1.24-2.45 1.871-1.058.656-2.38 1.273-3.763 1.371-.222 3.416.667 5.838 1.913 7.506Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ShieldCheck_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ShieldCheck;
exports["default"] = _default;